import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { Group } from './group.model';
import { GroupInterface } from './group.interface';
import { GroupFactory } from './group.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class GroupService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<Group>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<GroupInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/groups`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => GroupFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getRegisterAll(params: HttpParams): Observable<Array<Group>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<GroupInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/groups-register`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => GroupFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getImports(params: HttpParams): Observable<Array<Group>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<GroupInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/groups/new/imports`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => GroupFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<Group> {
        return this.http
            .get<GroupInterface>(`${environment.apiUrl}/v${environment.apiVersion}/groups/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => GroupFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(groups: Group): Observable<any> {
        if (groups.id) {
            return this.http
                .put(`${environment.apiUrl}/v${environment.apiVersion}/groups/${groups.id}`, groups, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/groups`, groups, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    updateOrder(groupId: string, items: any[]): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/groups`, { items }, { headers: this.authService.headers() })
            .pipe(map(item => GroupFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/groups/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<Group>> {
        return this.http
            .get<GroupInterface[]>(`${this.api}/groups/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawGroup => GroupFactory.fromObject(rawGroup)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/groups/shared/group.service.ts